<template>
  <div id="app">
    <home v-if="userId" />
    <login v-else />
  </div>
</template>

<script>
import atshq from "./js/setup";
import Home from "./my_project/Home.vue";
import Login from "./components/Login/Login.vue";
import axiosAdmin from "./js/setup";
import moment from 'moment-timezone'
moment.tz.setDefault('Asia/Dhaka')

export default {
  name: "App",
  components: {
    // HelloWorld
    Home,
    Login,
  },
  created() {
  },
  mounted() {
    let urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has("user_id")) {
      if (parseInt(urlParams.get("user_id")) === parseInt(localStorage.getItem('userId'))) {
        this.getUser();
      } else {
        this.userId = urlParams.get("user_id");
        localStorage.setItem("userId", this.userId);
        urlParams.delete("user_id");
        this.getUser();
      }
      this.$router.replace({'query': null})
    }
    if (urlParams.has("identity") && urlParams.has("password")) {
      this.formdata.email = urlParams.get("identity");
      this.formdata.password = urlParams.get("password");
      this.$router.replace({'query': null})
      this.Login2();

    }

    // Get Computer IP Address
    this.getComputerIP()
        .then((ip_address) => {
          if (!localStorage.getItem('local_ip_address')) {
            localStorage.setItem("local_ip_address", ip_address)
          }
        })
        .catch((error) => {
          console.error('Error fetching computer IP:', error);
        });

    // Add event listeners
    window.addEventListener('mousemove', this.resetInactivityTimer);
    window.addEventListener('keydown', this.resetInactivityTimer);
    window.addEventListener('click', this.resetInactivityTimer);

    // Start the inactivity timer
    this.startInactivityTimer();
  },
  beforeUnmount() {
    // Remove event listeners
    window.removeEventListener('mousemove', this.resetInactivityTimer);
    window.removeEventListener('keydown', this.resetInactivityTimer);
    window.removeEventListener('click', this.resetInactivityTimer);

    // Clear the inactivity timer
    clearTimeout(this.inactivityTimer);
  },
  methods: {
    getUser() {
      atshq
          .get("users/user/" + this.userId)
          .then((response) => {
            this.desserts = response.data.data;
            localStorage.setItem("userId", this.desserts.id);
            localStorage.setItem("userName", this.desserts.full_name);
            localStorage.setItem("specialPower", this.desserts.special_power);
          })
          .catch((e) => {
            console.log(e);
          });
    },
    Login2() {
      atshq
          .post("login", this.formdata)
          .then((response) => {
            localStorage.setItem("token", response.data.access_token);
            localStorage.setItem("userId", response.data.user.id);
            localStorage.setItem("userName", response.data.user.full_name);
            localStorage.setItem("specialPower", response.data.user.special_power);
            this.$noty.success(response.data.message);
            this.$router.replace({'query': null})
            location.reload()
            window.location.href = this.appUrl + 'auth/loginUsingParameter?identity=' + this.formdata.email + '&password=' + this.formdata.password
          })
          .catch((e) => {
            this.$noty.error(e.response.data.message);
          });
    },
    startInactivityTimer() {
      this.inactivityTimer = setTimeout(this.clearLocalStorage, 3 * 60 * 1000); // 3 minutes
    },
    resetInactivityTimer() {
      clearTimeout(this.inactivityTimer);
      this.startInactivityTimer();
    },
    clearLocalStorage() {
      // localStorage.clear();
      // location.reload()
      // window.open(atshq.defaults.headers.common.app_URL + "index.php/auth/logout");
      // localStorage.setItem("token", "");
      // localStorage.setItem("userId", "");
      // localStorage.setItem("userName", "");
      // localStorage.setItem("specialPower", "");
      // window.location.href = "/";
    },
    getComputerIP() {
      return new Promise((resolve, reject) => {
        const pc = new RTCPeerConnection();
        pc.onicecandidate = (event) => {
          if (event.candidate) {
            const ipAddress = event.candidate.address || '';
            resolve(ipAddress);
            pc.close();
          }
        };
        pc.createDataChannel('');
        pc.createOffer()
            .then((offer) => pc.setLocalDescription(offer))
            .catch(reject);
      });
    },
  },
  data() {
    return {
      appUrl: axiosAdmin.defaults.headers.common['app_URL'],
      token: localStorage.getItem("token"),
      userId: localStorage.getItem("userId"),
      formdata: {
        email: "",
        password: "",
      },
      inactivityTimer: '',
    };
  },
};
</script>